import React, { useEffect, useState } from 'react'
import './App.css'
import { RouterProvider } from 'react-router-dom'
import { routerDeleverItems } from './router'
import 'normalize.css'
import CartElemInfoModal from './pages/components/ModalWindows/CartElemInfoModal/CartElemInfoModal'
import Footer from "./pages/components/Footer/Footer"
import { useSelector } from 'react-redux'
import FavoriteModal from './pages/components/ModalWindows/FavoriteModal/FavoriteModal'
import AutoDataSynhronaizer from './pages/components/AutoDataSynhronaizer/AutoDataSynhronaizer'
import ItemCardModal from './pages/components/ModalWindows/ItemCardModal/ItemCardModal'
import WarningModal from './pages/components/ModalWindows/WarningModal/WarningModal'
import AlertModal from './pages/components/ModalWindows/AlertModal/AlertModal'
import ErrorHandler from './pages/ErrorPage/ErrorHandler'
import useSendLog from './hooks/useSendLog'
import { HelmetProvider } from 'react-helmet-async'
import SalesAlert from './pages/components/SalesAlert/SalesAlert'

const App = () => {
  const openFavoriteModal = useSelector(state => state.contextUI.uiModal.favoriteModal)
  const ItemModalData = useSelector(state => state.contextUI.uiModal.itemModal)


  const sendUserStats = useSendLog('User stats', { 
    device: navigator.userAgent,
    typeOfDevice: navigator.platform,
    os: navigator.oscpu,
    browser: navigator.appName,
    browserVersion: navigator.appVersion
  })

  console.log("auto deploy is work 2.0")

  return (
    <div className='App'>
      <ErrorHandler>
        <HelmetProvider>
          <div className='App__padding'>
            <RouterProvider router={routerDeleverItems} />

            {openFavoriteModal && <FavoriteModal />}
            <CartElemInfoModal />


            <AutoDataSynhronaizer />
            <AlertModal/>
            <SalesAlert />
            {ItemModalData.isShow ? (
              <ItemCardModal card={ItemModalData.item} />
            ) : null}
          </div>
        </HelmetProvider>
      </ErrorHandler>

      <Footer />
    </div>
  )
}

export default App
